import { CustomerDetailsSectionMessageDenormalizer } from "./customer-details-section-message";
import { IInboxMessage, INormalizedInboxMessage } from "./inbox-message";
import { IInboxMessageDenormalizer } from "./inbox-message-denormalizer";
import { PluginInitedMessageDenormalizer } from "./plugin-inited-message";
import { PluginLoadedMessageDenormalizer } from "./plugin-loaded-message";

export const inboxMessageDenormalizers = new Map(
  [PluginLoadedMessageDenormalizer, PluginInitedMessageDenormalizer, CustomerDetailsSectionMessageDenormalizer].map(
    denormalizer => [denormalizer.messageTitle, denormalizer] as [string, IInboxMessageDenormalizer]
  )
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createInboxMessage(title: string, pluginId: string, data: any = null): IInboxMessage {
  return { title, pluginId, data };
}

export function normalizeInboxMessage(message: IInboxMessage): INormalizedInboxMessage {
  return {
    message: message.title,
    plugin_id: message.pluginId,
    data: message.data || null,
  };
}

export function denormalizeInboxMessage(message: INormalizedInboxMessage): IInboxMessage {
  const denormalizer = inboxMessageDenormalizers.get(message.message);

  return denormalizer
    ? denormalizer.createMessage(message)
    : createInboxMessage(message.message, message.plugin_id, message.data);
}
